export const AGENT_VALIDATION_SUBMITTED = 'AGENT_VALIDATION_SUBMITTED';
export const GET_AGENT_VERIFICATION_EMAIL = 'GET_AGENT_VERIFICATION_EMAIL';
export const RESET_REQUEST_TIMEOFF = 'RESET_REQUEST_TIMEOFF';
export const CLEAR_INFO = 'CLEAR_INFO';
export const GET_VERIFICATION_DATA = 'GET_VERIFICATION_DATA';


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/redux/constants.js